import { render, staticRenderFns } from "./RoomsSchedulesTab.vue?vue&type=template&id=eb5c48d4&scoped=true&lang=pug"
import script from "./RoomsSchedulesTab.vue?vue&type=script&lang=ts"
export * from "./RoomsSchedulesTab.vue?vue&type=script&lang=ts"
import style0 from "./RoomsSchedulesTab.vue?vue&type=style&index=0&id=eb5c48d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb5c48d4",
  null
  
)

export default component.exports